var dataOption = 'data-option';
var dropdownOption = 'dropdown-option';
var selectedDropdown = '[data-hook="selected-dropdown"]';
export var dataHooks = {
  dropDownInput: 'drop-down-input',
  selectedDropdownValueSelector: "".concat(selectedDropdown, " [value]"),
  dataOptionHookWithValue: function dataOptionHookWithValue(value) {
    return "[".concat(dataOption, "*=\"").concat(dropdownOption, "-").concat(value, "\"]");
  },
  dataOptionHookWithLabel: function dataOptionHookWithLabel(label) {
    return "[".concat(dataOption, "$=\"").concat(label, "\"]");
  },
  dataOptionStartWithValue: function dataOptionStartWithValue(value) {
    return "[".concat(dataOption, "^=\"").concat(dropdownOption, "-").concat(value, "\"]");
  },
  dataOptionWithValueAndLabel: function dataOptionWithValueAndLabel(value, label) {
    return "".concat(dropdownOption, "-").concat(value, "-").concat(label);
  },
  selectedDropdownContent: "".concat(selectedDropdown, " .control-dropdown-option-content")
};